import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { routes } from './routes';
import { Toaster } from '@/components';

const router = createBrowserRouter(routes);

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, staleTime: 60 * 1000 } },
});

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster />
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
};
